import { Group, Text } from "@mantine/core";
import { DataGridPage, EntityClientAction } from "@mcurros2/microm";
import { IconAlertCircle } from "@tabler/icons-react";
import { ClientesVmi } from "./ClientesVmi/ClientesVmi";

export const ACTVerImportaciones: EntityClientAction = {
    name: 'ACTVerImportaciones',
    label: 'Ver Importaciones',
    title: <Text fw={700}>Ver Importaciones</Text>,
    refreshOnClose: true,
    dontRequireSelection: false,
    views: ['clie_brwStandard'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const clientesVmi = new ClientesVmi(entity.API.client);
        clientesVmi.parentKeys = entity.parentKeys;
        clientesVmi.def.columns.c_cliente_backoffice_id.value = selectedKeys![0].c_cliente_id as unknown as string || '';

        await modal.open({
            modalProps: {
                title: <Group><IconAlertCircle size="1.5rem" stroke="1.5" /> <Text fw="700">Importaciones</Text></Group>,
                size: "xl"
            },
            focusOnClosed: element,
            content: <DataGridPage
                key="importacion-datos"
                client={entity.API.client}
                entityConstructor={() => clientesVmi}
                formMode="view"
                viewName="cvmi_brwPorClienteBackoffice"
                refreshOnInit
                enableAdd={false}
                enableDelete={false}
                enableEdit={false}
                enableView={true}
                selectionMode="single" />     
        });

        return false;
    }
}